/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue May 27 2025
 **/

import { Row, TypographyTooltip } from "@/frameworks/designStuff";

export default function PhoneNumberProfile(props: PushServices.Call.PhoneDetailProps & { isBlockedByMe?: boolean }) {
	const { callees } = props;
	const phoneNumber = callees[0].callGatewayClient?.callNumber || "";

	return (
		<Row verticalAlign="center" horizonAlign="center" style={{ width: "100%" }}>
			<Row css={{ width: "100%" }} horizonAlign="center" verticalAlign="center" gap={8}>
				<Row css={{ maxWidth: "calc(100% - 18px)" }}>
					<TypographyTooltip.p
						tooltipProps={{
							hasIcon: false
						}}
						componentProps={{
							typoSize: "Head6",
							ellipsis: true,
							maxLine: 1,
							stretch: true,
							align: "center"
						}}
					>
						{phoneNumber}
						{props.isBlockedByMe && " (차단됨)"}
					</TypographyTooltip.p>
				</Row>
			</Row>
		</Row>
	);
}
